<template>
  <div class="monthlist">
    <div class="comp-full-calendar">
      <div class="month-title">
        <div class="title">
          <div>
            <i class="el-icon-date" @click="displayleft"></i>
            <span>卡片视图</span>
          </div>
          <div class="">
            <!-- <el-switch
              class="nav-rt-sw"
              v-model="switchVal"
              :width="33"
              active-color="#13ce66"
              inactive-color="#bbbbbc"
              @change="switchChang"
            >
            </el-switch> -->
            <span></span>
          </div>
        </div>
      </div>
      <div class="header-center">
        <div id="certify">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in cardsData"
                :style="getThemeStyleContainer()"
                :key="index"
              >
                <div class="swiper-slide-box">
                  <div class="swiper-slide-box-title">
                    <div class="swiper-slide-box-title-left">
                      <img
                        src="../../assets/img/cards/today.png"
                        style="margin-right: 18px"
                        v-if="index === 6"
                        alt=""
                      />
                      <b>{{ item.title }}</b>
                    </div>
                    <div class="swiper-slide-box-title-right">
                      <img
                        v-if="index === 6"
                        src="../../assets/img/list/add.png"
                        class="swiper-slide-box-title-right-add"
                        @click="addTodoItem(item.title)"
                      />
                    </div>
                  </div>

                  <ul class="swiper-slide-box-list">
                    <li
                      class="swiper-slide-box-list-item"
                      v-for="(item_list, index_list) in item.list"
                      :key="index_list"
                      :style="
                        item_list.isloading
                          ? 'text-decoration: line-through;'
                          : ''
                      "
                    >
                      <input
                        @change="successItem(item_list, item.list)"
                        type="checkbox"
                        :disabled="item_list.task_name === '暂无'"
                        style="
                          width: 20px;
                          height: 20px;
                          border: 1px solid #f00;
                        "
                      />
                      &nbsp;&nbsp;{{ item_list.task_name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer> -->

    <el-dialog title="添加" :visible.sync="dialog.Visible" width="30%">
      <!-- :before-close="handleClose" -->
      <!-- <span>这是一段信息</span> -->
      <el-input
        placeholder="请输入内容"
        @keypress.enter.native="addTodoItemRqueest"
        v-model="dialog.task_name"
        clearable
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.Visible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addTodoItemRqueest"
          :loading="dialog.isloading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
// import dateFunc from '../../util/dateFunc'
// import bus from '../../util/bus'
// import leftNav from "../../components/content/leftNav";
// import fcBody from "../../components/vue-fullcalendar/body";

import Swiper from 'swiper'
import '../../assets/css/swiper.min.css'
import {mapGetters} from 'vuex' 
import util from '../../util/util'

export default {
  // components: {
  //   "fc-body": fcBody,
  //   leftNav,
  // },

  data() {
    return {
      dialog: {
        Visible: false,
        isloading: false,
        date: '',
        task_name: ''
      },
      fcEvents: [],
      interviewEvent: {},
      monms: '',
      Swiper: null,
      cardsData: [
        // {
        //   title: '今天',
        //   list: [
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' }
        //   ]
        // },
        // {
        //   title: '周一',
        //   list: [{ title: '暂无' }]
        // },
        // {
        //   title: '周二',
        //   list: [
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' }
        //   ]
        // },
        // {
        //   title: '周三',
        //   list: [
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' }
        //   ]
        // },
        // {
        //   title: '周四',
        //   list: [
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' }
        //   ]
        // },
        // {
        //   title: '周五',
        //   list: [
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' }
        //   ]
        // },
        // {
        //   title: '周六',
        //   list: [
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' },
        //     { title: '每天自律每天自律每天自律每天自律' }
        //   ]
        // }
      ]

      //top
      // title: "",
      // headDate: new Date(),
      // titleFormat: "yyyy/MM",
      // monthNames: [
      //   "1月",
      //   "2月",
      //   "3月",
      //   "4月",
      //   "5月",
      //   "6月",
      //   "7月",
      //   "8月",
      //   "9月",
      //   "10月",
      //   "11月",
      //   "12月",
      // ],

      // events: [],
      // weekDays: [],
      // switchVal: false,
      //  drawer: false,
    }
  },
  props: {
    firstDay: {
      type: Number | String,
      validator(val) {
        let res = parseInt(val)
        return res >= 0 && res <= 6
      },
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  watch: {},

  created() {
    //
  },
  methods: {
    ...mapGetters('theme', ['getThemeStyle','getThemeStyleContainer', 'getTheme']),
    //左边显示
    displayleft() {
      if (document.body.clientWidth <= 1200) {
        this.drawer = true
      }
    },
    getTime(date) {
      var seperator1 = '-'
      var seperator2 = ':'
      //以下代码依次是获取当前时间的年月日时分秒
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var minute = date.getMinutes()
      var hour = date.getHours()
      var second = date.getSeconds()
      //固定时间格式
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
      }
      if (minute >= 0 && minute <= 9) {
        minute = '0' + minute
      }
      if (second >= 0 && second <= 9) {
        second = '0' + second
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    //获取数据
    // fetchEventsList() {
    //   console.log(this.headDate);
    //   let data =
    //     this.headDate.getFullYear() + "-" + (this.headDate.getMonth() + 1);
    //   let header = {
    //     Authorization: "Bearer " + localStorage.getItem("token"),
    //   };
    //   this.$api
    //     .monthday(data, header)
    //     .then((res) => {
    //       this.events = res.data.result;
    //       console.log(res, "获取数据ggggggg");
    //     })
    //     .catch((err) => {});
    // },

    // goPrev() {
    //   this.headDate = this.ceDateRange(this.headDate, -1);
    //   this.dispatchEvent();
    //   this.fetchEventsList();
    // },
    // goNext() {
    //   this.headDate = this.ceDateRange(this.headDate, 1);
    //   this.dispatchEvent();
    //   this.fetchEventsList();
    // },
    // ceDateRange(date, num) {
    //   let dt = new Date(date);
    //   return new Date(dt.setMonth(dt.getMonth() + num));
    // },
    // dispatchEvent() {
    //   this.title = dateFunc.format(
    //     this.headDate,
    //     this.titleFormat,
    //     this.monthNames
    //   );
    //   let startDate = dateFunc.getStartDate(this.headDate);
    //   let curWeekDay = startDate.getDay();
    //   let diff = parseInt(this.firstDay) - curWeekDay;
    //   if (diff) diff -= 7;
    //   startDate.setDate(startDate.getDate() + diff);
    //   let endDate = dateFunc.changeDay(startDate, 41);
    //   let currentDate = dateFunc.getStartDate(this.headDate);
    // },
    // // 显示隐藏
    // switchChang(e) {
    //   console.log(e, "点击的switch的值");
    //   this.switchVal = e;
    // },

    /************************************************************************
     * 初始化swiper Dom
     */
    initSwiperDom() {
      this.$nextTick(() => {
        if (this.Swiper) {
          return this.Swiper.update()
        }

        this.Swiper = new Swiper('#certify .swiper-container', {
          watchSlidesProgress: true,
          slidesPerView: 'auto',
          centeredSlides: true,
          initialSlide: 7,
          loop: false,
          loopedSlides: 5,
          autoplay: false,
          init: true,
          on: {
            //
            progress: function (progress) {
              for (let i = 0; i < this.slides.length; i++) {
                const slide = this.slides.eq(i)
                const slideProgress = this.slides[i].progress
                var modify = 1
                if (Math.abs(slideProgress) > 1) {
                  modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
                }
                var translate = slideProgress * modify * 260 + 'px'
                var scale = 1 - Math.abs(slideProgress) / 5
                var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
                slide.transform(
                  'translateX(' + translate + ') scale(' + scale + ')'
                )
                slide.css('zIndex', zIndex)
                slide.css('opacity', 1)
                if (Math.abs(slideProgress) > 3) {
                  slide.css('opacity', 0)
                }
              }
            },
            setTransition: function (transition) {
              //
              for (var i = 0; i < this.slides.length; i++) {
                var slide = this.slides.eq(i)
                slide.transition(transition)
              }
            }
          }
        })
      })
    },
    /************************************************************************
     * 初始化swiper数据
     */
    initSwiper() {
      this.cardsData = []
      let header = {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
      this.$api
        .weekday(new Date().toLocaleDateString().replace(/\//g, '-'), header)
        .then((res) => {
          console.log('卡片视图：', res.data.result)
          const Times = util.lastWeekDays(-7, 1).reverse()

          res.data.result.forEach((item, index) => {
            const data =
              Times[index].date.toLocaleDateString().replace(/\//g, '-') +
              Times[index].week

            /**
             * 未完成
             */
            const wwc = item.filter((item) => {
              item.isloading = false
              return !item.task_status
            })

            this.cardsData.push({
              title: `${data}`,
              list:
                wwc.length === 0
                  ? [{ task_name: '暂无', isloading: false }]
                  : wwc
            })
          })
          this.cardsData.reverse()

          this.initSwiperDom()
        })
    },
    /************************************************************************
     * 点击复选框调用接口一些列动作
     */
    successItem(item, arr) {
      item.isloading = true
      let header = {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
      let data = {
        todo_id: item.id
      }

      this.$api.completed(data, header).then((res) => {
        setTimeout(() => {
          this.initSwiper()
        }, 200)
      })
    },
    /************************************************************************
     * 点击添加之后弹出框式添加内容 以及请求发送
     */
    addTodoItem(time) {
      console.log((this.dialog.date = time.split('星期')[0]))
      this.dialog.Visible = true
    },
    addTodoItemRqueest() {
      console.log(this.dialog)
      let header = {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
      let data = {
        task_name: this.dialog.task_name,
        task_repeat: 0,
        type: 3,
        task_time:new Date().toLocaleDateString().replace(/\//g, '-'),
        todo_from:""
      }
      this.dialog.isloading = true
      this.$api
        .releasetodo(data, header)
        .then(() => {
          this.initSwiper()
          this.dialog.Visible = false
          this.dialog.isloading = false
        })
        .catch(() => {
          this.dialog.isloading = false
          this.dialog.Visible = false
        })
    }
  },
  mounted() {
    this.initSwiper()
  }
}
</script>
<style scoped lang="scss">
.monthlist {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  padding: 0 20px;
  background-color: var(--color-theme);

  // .navlef {
  //   width: 19%;
  // }
  .comp-full-calendar {
    width: 100%;
    height: 100%;
    margin: 0 2%;
    margin: 0 auto;
    .month-title {
      padding-top: 50px;
    }
    .title {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 40px;
      > :first-child {
        i {
          font-size: 22px;
          margin-right: 10px;
        }
        span {
          font-size: 24px;
          font-weight: bold;
        }
      }
      > :last-child {
        display: flex;
        align-items: center;
        span {
          font-size: 18px;
          color: gray;
          margin-left: 10px;
        }
      }
    }
    .time {
      line-height: 30px;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
    .header-center {
      position: relative;
      height: 80%;
      .btn {
        position: absolute;
        z-index: 100;
        height: 36px;
        width: 36px;
        line-height: 36px;
        cursor: pointer;
        transition: 0.3s;
        border-radius: 50%;
        background-color: rgba(31, 45, 61, 0.11);
        color: #fff;
        text-align: center;
      }
      .up {
        left: 25px;
        top: 50%;
      }
      .down {
        right: 25px;
        top: 50%;
      }
    }
  }
}

/* CSS Swiper Container */
#certify {
  position: relative;
  width: 1200px;
  margin: 0 auto;

  .swiper-container {
    // padding-bottom: 60px;
    .swiper-slide {
      width: 520px;
      height: 610px;

      // background-color: #323232;
      box-shadow: 0px 9px 35px 0px rgba(0, 0, 0, 0.31);
      border-radius: 20px;
      // color: #cccccc;

      .swiper-slide-box {
        width: 100%;
        height: 100%;
        .swiper-slide-box-title {
          display: flex;
          padding: 0 30px;
          height: 77px;
          justify-content: space-between;
          align-items: center;

          .swiper-slide-box-title-left {
            display: flex;
            height: 77px;
            align-items: center;
          }
          .swiper-slide-box-title-right {
            .swiper-slide-box-title-right-add {
              cursor: pointer;
            }
          }
        }
        .swiper-slide-box-list {
          // overflow-y: auto;
          // max-height: calc(100% - 77px);
          // 这滚动条放出来真丑。。。
          max-height: calc(100% - 85px);
          overflow-y: hidden;
          padding: 0 40px;
          line-height: 40px;

          font-size: 20px;
          // color: #cccccc;
          &-item {
            cursor: pointer;
          }
        }
      }
      img {
        display: block;
      }
    }
  }
}
</style>
